import React, {useState} from 'react';
import './LeadManage.scss';
import LeadManageTabs from "./LeadManageItems/LeadManageTabs";
import LeadsList from "./LeadManageItems/LeadsList";
import RecordFollowUps from "./LeadManageItems/RecordFollowUps";
import LeadCase from "./LeadManageItems/LeadCase";
import TodayFollowUp from "./LeadManageItems/TodayFollowUp";
import LeadReport from "./LeadManageItems/LeadReport";

const LeadManage = () => {

  const [activeTab, setActiveTab] = useState(1);
  const [initialDataRecordFollowUps, setInitialDataRecordFollowUps] = useState({});
  const [initialDataLeadsList, setInitialDataLeadsList] = useState({});
  const [reRenderLeadsList, setReRenderLeadsList] = useState(0)

  const [leadIdFromList, setLeadIdFromList] = useState("");

  return (
    <section className={"LeadManage"}>
      <LeadManageTabs activeTab={activeTab} setActiveTab={setActiveTab}/>
      <div className={"tab-content"}>
        {activeTab === 1 ?
          <LeadsList initialData={initialDataLeadsList}
                     setInitialData={setInitialDataLeadsList}
                     setLeadIdFromList={setLeadIdFromList}
                     setActiveTab={setActiveTab}
                     leadIdFromList={leadIdFromList}
                     reRender={reRenderLeadsList}
                     setReRender={setReRenderLeadsList}/> :
          activeTab === 2 ?
            <RecordFollowUps initialData={initialDataRecordFollowUps}
                             setInitialData={setInitialDataRecordFollowUps}
                             leadIdFromList={leadIdFromList}
                             setActiveTab={setActiveTab}
                             setReRenderLeadsList={setReRenderLeadsList}/> :
            activeTab === 3 ?
              <LeadCase initialData={initialDataRecordFollowUps}
                        setInitialData={setInitialDataRecordFollowUps}
                        leadIdFromList={leadIdFromList}/> :
              activeTab === 4 ?
                <TodayFollowUp setLeadIdFromList={setLeadIdFromList}
                               leadIdFromList={leadIdFromList}
                               setActiveTab={setActiveTab}/> :
                <LeadReport/>
        }
      </div>
    </section>
  );
};

export default LeadManage;